import React, { createContext, useReducer, useContext, useRef } from "react";
import ClassTypesReducer from "../reducers/ClassTypesReducer";
import ClassTypesService from "../services/ClassTypesService";
import {
  CLASS_TYPES_RECIBIDOS,
  CREATE_CLASS_TYPE,
  SET_CLASS_TYPE,
  SET_FILTER,
  SET_PROPIEDAD_CLASS_TYPE,
} from "../types";
import { ModalContext } from "./ModalContext";

const initialState = {
  class_types: null,
  class_type: null,
};

export const ClassTypeContext = createContext(initialState);

export const ClassTypeProvider = ({ children }) => {
  const [state, dispatch] = useReducer(ClassTypesReducer, initialState);

  const { success } = useContext(ModalContext);

  const latestRequestId = useRef(0);
  const latestFilters = useRef({});

  const filtersMatch = (a, b) => {
    const keys = new Set([...Object.keys(a), ...Object.keys(b)]);
    for (const key of keys) {
      const av = a[key] == null ? "" : String(a[key]);
      const bv = b[key] == null ? "" : String(b[key]);
      if (av !== bv) return false;
    }
    return true;
  };

  const getClassTypes = (filters = {}) => {
    Object.keys(filters).forEach((key) => {
      dispatch({ type: SET_FILTER, payload: { key, value: filters[key] } });
    });
    const requestId = ++latestRequestId.current;
    latestFilters.current = filters;
    dispatch({ type: CLASS_TYPES_RECIBIDOS, payload: null });
    ClassTypesService.getClassTypes(filters).then((res) => {
      if (requestId !== latestRequestId.current) return;
      if (!filtersMatch(filters, latestFilters.current)) return;
      const { class_types } = res.data;
      dispatch({ type: CLASS_TYPES_RECIBIDOS, payload: class_types });
    });
  };

  const getClassType = (class_type_id) => {
    ClassTypesService.getClassTypes().then((res) => {
      const { class_types } = res.data;
      let class_type = class_types.find(
        (tipo) => parseInt(tipo.class_type_id) === parseInt(class_type_id)
      );
      dispatch({ type: SET_CLASS_TYPE, payload: class_type });
    });
  };

  const createClassType = () => {
    dispatch({ type: CREATE_CLASS_TYPE });
  };

  const setPropiedadClassType = (key, value) => {
    dispatch({ type: SET_PROPIEDAD_CLASS_TYPE, payload: { key, value } });
  };

  const deleteClassType = (class_type_id) => {
    ClassTypesService.deleteClassType(class_type_id).then(() => {
      success("Tipo de clase eliminado.");
    });
  };

  const clearClassTypes = () => {
    dispatch({ type: CLASS_TYPES_RECIBIDOS, payload: null });
  };

  return (
    <ClassTypeContext.Provider
      value={{
        ...state,
        getClassType,
        getClassTypes,
        createClassType,
        deleteClassType,
        clearClassTypes,
        setPropiedadClassType,
      }}
    >
      {children}
    </ClassTypeContext.Provider>
  );
};
